var APPOINTMENT_TYPE_ID;
var APPOINTMENT_MONTHS;
var APPOINTMENT_NAME;

function initReserveForm(at, name, months) {
  APPOINTMENT_TYPE_ID = at;
  APPOINTMENT_NAME = name;
  APPOINTMENT_MONTHS = months;

  // 現在の月を取得する
  let now = new Date();
  let tomonth = dateToStr12HPad0(now, "YYYY-MM");

  // 当月の日付データを取得する
  initReserveHtml();
  getReserveDates(APPOINTMENT_TYPE_ID, tomonth);
}

function initReserveHtml() {
  $('#reserve-form').html(`
    <div class="reserve-name">` + NAME + `</div>

    <div class="reserve-form-datetime reserve-form-section">
      <h2 class="step-title"><span class="step-number">1</span> 日時選択</h2>
      <div id="reserve-form-dates"></div>
      <div id="reserve-form-times"></div>
    </div>

    <div class="reserve-form-selectitem reserve-form-section">
      <h2 class="step-title"><span class="step-number">2</span> 予約内容入力</h2>
      <div id="reserve-form-contact"></div>
      <div id="reserve-form-items"></div>
    </div>

    <div class="reserve-form-submit reserve-form-section">
      <h2 class="step-title"><span class="step-number">3</span> 予約完了</h2>
      <div id="reserve-form-result"></div>
    </div>
    `);
}

function startLoading() {
  $('#reserve-form').html('<div class="loader"></div>');
}

function setLoading(ele) {
  $(ele).html('<div class="loader"></div>');
}

function showLoadingDate() {
  $('#reserve-form-dates').html('<div class="loader"></div>');
}
function showLoadingTime() {
  $('#reserve-form-times').html('<div class="loader"></div>');
}
function showLoadingItem() {
  $('#reserve-form-items').html('<div class="loader"></div>');
}
function showLoadingResult() {
  $('#reserve-form-result').html('<div class="loader"></div>');
}

function showReserveDates(data) {
  //console.log(data);
  let dates = data.dates;
  let htmls = [];
  htmls.push('<select class="reserve-form-date-list" name="reserve-date" onchange="changeReserveDate()">');
  htmls.push('<option value="">日付を選択してください</option>');
  for (let date of dates) {
    //console.log(date);
    let dt = new Date(date.date);
    let date_str = dateToStr12HPad0(dt, "YYYY年MM月DD日 (WW)")
    htmls.push('<option value="' + date.date + '">' + date_str + '</option>');
  }
  htmls.push('</select>');
  let html = htmls.join("\n");
  $('#reserve-form-dates').html(html);
}

function changeReserveDate() {
  let date = $("[name='reserve-date']").val();
  console.log("select date: " + date);

  if (!date || date == "") {
    // 時間を選択してください
    $('#reserve-form-times').html("");
    $('#reserve-form-contact').html("");
    $('#reserve-form-items').html("");
    return;
  } else {
    $('#reserve-form-contact').html("");
    $('#reserve-form-items').html("");
    getReserveTimes(APPOINTMENT_TYPE_ID, date);
  }
  // 時間を取得する
}

function showReserveTimes(data) {
  //console.log(data);
  let times = data.times;
  let htmls = [];
  htmls.push('<select class="reserve-form-time-list" name="reserve-time" onchange="changeReserveTime()">')
  htmls.push('<option value="">時間を選択してください</option>');
  for (let time of times) {
    //console.log(time);

    let dt = new Date(time.time);
    let shour = dt.getHours();
    let ehour = shour + 1;
//    let time_str = dateToStr12HPad0(dt, "hh時");
    let time_str = shour + ":00 〜 " + ehour + ":00";

    htmls.push('<option value="' + time.time + '">' + time_str + '</option>');
  }
  htmls.push('</select>');
  let html = htmls.join("\n");
  $('#reserve-form-times').html(html);
}

function changeReserveTime() {
  let datetime = $("[name='reserve-time']").val();

  if (!datetime || datetime == "") {
    // 未選択なので何もしない
    $('#reserve-form-contact').html("");
    $('#reserve-form-items').html("");
    return;
  }
  console.log("select time: " + datetime);

  // 連絡先フォームを表示する
  showReserveContact();
  // 商品を取得する
  getReserveForm(APPOINTMENT_TYPE_ID, datetime);
}

function showReserveContact() {

  // すでに入力中の場合は、更新しない
  // name (last first)
  let firstname = $("[name='first-name']").val();
  let lastname = $("[name='last-name']").val();
  // tel
  let tel = $("[name='tel']").val();
  // email
  let email = $("[name='email']").val();

  if (firstname && firstname != "") {
    console.log("skip contact");
    return;
  }
  else if (lastname && lastname != "") {
    console.log("skip contact");
    return;
  }
  else if (tel && tel != "") {
    console.log("skip contact");
    return;
  }
  else if (email && email != "") {
    console.log("skip contact");
    return;
  }

  let htmls = [];
  htmls.push(`<div class="reserve-form-wrapper">
    <div class="input-block">
      <label class="reserve-form-label">氏名 <span class="required">*</span></label>
      <div class="flex-wrapper">
        <input class="reserve-form-input mr8" type="text" name="last-name" placeholder="姓">
        <input class="reserve-form-input ml8" type="text" name="first-name" placeholder="名">
      </div>
    </div>

    <div class="input-block">
    <label class="reserve-form-label">電話番号 (半角、ハイフンなし)</label>
    <input class="reserve-form-input" type="text" name="tel">
    </div>

    <div class="input-block">
    <label class="reserve-form-label">メールアドレス (半角) <span class="required">*</span></label>
    <input class="reserve-form-input" type="email" name="email">
    </div>
  </div>`);

  let html = htmls.join('\n');
  //console.log(html);

  $('#reserve-form-contact').html(html);
}

function showReserveForm(data) {

  let htmls = [];
  /**
  htmls.push(`<div class="reserve-form-wrapper">
    <div class="input-block">
      <label class="reserve-form-label">氏名 <span class="required">*</span></label>
      <div class="flex-wrapper">
        <input class="reserve-form-input mr8" type="text" name="last-name" placeholder="姓">
        <input class="reserve-form-input ml8" type="text" name="first-name" placeholder="名">
      </div>
    </div>

    <div class="input-block">
    <label class="reserve-form-label">電話番号</label>
    <input class="reserve-form-input" type="text" name="tel">
    </div>

    <div class="input-block">
    <label class="reserve-form-label">メールアドレス (半角)<span class="required">*</span></label>
    <input class="reserve-form-input" type="email" name="email">
    </div>
  </div>`);
  */

  if (data && data.form) {
    // フォーム情報を表示する
    let limit = {};
    if (data.limit) {
      limit = data.limit;
    }
    let form = data.form;
    let fields = form.fields;
    htmls.push('<div class="reserve-form-wrapper">');
    htmls.push('<h2 class="reserve-form-title">ご予約商品</h2>');
    for (let field of fields) {

      let is_limit = false;
      if (limit[field.id]) {
        is_limit = true;
        let limit_row = limit[field.id];
      }

      htmls.push('<div class="input-block">');
      if (field.type == "dropdown") {
        let disabled_html = "";
        let limit_html = "";
        if (is_limit && limit[field.id].num == 0) {
          disabled_html = "disabled";
          limit_html = " 事前予約分完売";
        }
        if (field.required) {
          htmls.push('<label class="reserve-form-label">' + field.name + ' <span class="required">*' + limit_html + '</span></label>');
        } else {
          htmls.push('<label class="reserve-form-label">' + field.name + '</label>');
        }

        htmls.push('<select data-field-id="' + field.id + '" class="reserve-form-select" name="' + field.id + '" ' + disabled_html + '>');
        for (let opt of field.options) {
          if (is_limit && limit[field.id].num < opt) {
            break;
          }
          htmls.push('<option value="' + opt + '">' + opt + '</option>');
        }
        htmls.push('</select>');
      }
      else if (field.type == "checkbox") {
        htmls.push('<div class="reserve-form-inline">');
        htmls.push('<input id="' + field.id + '" data-field-id="' + field.id + '" class="reserve-form-checkbox" type="checkbox" name="' + field.id + '" value="yes">');
        if (field.required) {
          htmls.push('<label class="reserve-form-label" for="' + field.id +'">' + textToLink(field.name) + ' <span class="required">*</span></label>');
        } else {
          htmls.push('<label class="reserve-form-label" for="' + field.id +'">' + textToLink(field.name) + '</label>');
        }
        htmls.push('</div>');
      }
      htmls.push('</div>');
    }
    htmls.push('</div>');
  } else {
    // エラーにしておく
  }

  htmls.push('<div style="display: none;" id="reserve-form-button-error">入力内容を確認してから、もう一度「予約する」ボタンを押してください</div>')

  // 追加ボタンを入れる
  htmls.push('<div class="reserve-form-button-wrapper">');
  htmls.push('<button class="reserve-form-button" onclick="checkReserveForm()">予約する</button>');
  htmls.push('</div>');


  let html = htmls.join('\n');
  //console.log(html);

  $('#reserve-form-items').html(html);

  //console.log(data);
}

/**
 *
 */
function checkReserveForm() {
  console.log("check reserve");

  $('.reserve-form-button').prop('disabled', true);
  $('.reserve-form-button').addClass('sending');
  $('.reserve-form-button').text('送信中...');

  // datetime
  let datetime = $("[name='reserve-time']").val();
  let at = APPOINTMENT_TYPE_ID;

  // name (last first)
  let firstname = $("[name='first-name']").val();
  let lastname = $("[name='last-name']").val();
  // tel
  let tel = $("[name='tel']").val();
  // email
  let email = $("[name='email']").val();

  $("[name='first-name']").removeClass('error');
  $("[name='last-name']").removeClass('error');
  $("[name='email']").removeClass('error');

  let errors = [];
  if (!firstname || firstname == "") {
    // error name
    $("[name='first-name']").addClass('error');
    errors.push({ error: "name" });
  }
  if (!lastname || lastname == "") {
    $("[name='last-name']").addClass('error');
  }
  if (!email || email == "") {
    $("[name='email']").addClass('error');
    errors.push({ error: "email" });
  }
  if (!validation_email(email)) {
    $("[name='email']").addClass('error');
    errors.push({ error: "email" });
  }

  // fields
  let fields = [];
  let fields_eles = $('[data-field-id]');
  for (let ele of fields_eles) {
    let type = $(ele).attr('type');
    let val = $(ele).val();
    let id  = $(ele).data('field-id');

    //console.log(ele);
    //console.log("type: " + type);
    //console.log("id: " + id);
    //console.log("val: " + val);

    if (type == "checkbox") {
      let checked = $(ele).prop('checked');
      //console.log("checked: " + checked);
      if (!checked) {
        $(ele).addClass('error');
        errors.push({ error : "fields", id: id });
      } else {
        $(ele).removeClass('error');
      }
    }
    fields.push({ "id": id, "value": val });
  }

  if (errors && errors.length > 0) {
    // エラー表示
    //let message = '<p class="error">確認してください</p>';
    //$('#reserve-form-contact').insertBefore(message);
    // window.location.hash = "reserve-form-contact";

    $('.reserve-form-button').prop('disabled', false);
    $('.reserve-form-button').removeClass('sending');
    $('.reserve-form-button').text('予約する');

    $('#reserve-form-button-error').show();

  } else {

    $('#reserve-form-button-error').hide();

    // 登録する処理を行う
    let param = {};
    param["firstname"] = firstname;
    param["lastname"] = lastname;
    param["email"] = email;
    param["tel"]  = tel;
    param["datetime"] = datetime;
    param["fields"] = fields;

    registReserveForm(APPOINTMENT_TYPE_ID, param);

  }
}


function updateReserveForm() {
  // 通信して確認する
}

function showReserveResult(data) {

  //console.log(data);
  let row = data.data;

  let reserve_no = row.id;
  let dt = new Date(row.datetime);
  let date_str = dateToStr12H(dt,"Y年M月D日（W）");
  let shour = dt.getHours();
  let ehour = shour + 1;
  let time_str = shour + ":00 〜 " + ehour + ":00";

  //let datetime_str = "2022年9月12日 (金) 11:00 〜 12:00";
  let datetime_str = date_str + " " + time_str;
  let address_str = row.location;

  $('#reserve-form-result').html(`
  <div class="reserve-form-result-content">
    <h2 class="reserve-form-title">予約番号：` + reserve_no + `</h2>

    <p>` + APPOINTMENT_NAME + `</p>
    <p>日時：` + datetime_str + `</p>
    <p>場所：` + address_str + `</p>

    <div class="reserve-form-result_notice">
    <p>入力いただいたメールアドレスに確認メールを送付しますので、必ずご確認ください。
    もしメールが届かない場合は、お問い合わせください。<br>
    当日は、店頭スタッフにご予約番号下4桁とお名前をお伝えいただきますようお願いいたします。</p>
    </div>
  </div>
  `);

  $('.reserve-form-button').text('予約完了しました');
}

function errorReserveForm() {
  $('#reserve-form-form').html('<div class="reserve-form-error">通信エラーが発生しました。もう一度ページを読み込みし直してください。</div>')
}
function errorReserveItems() {
  $('#reserve-form-items').html('<div class="reserve-form-error">通信エラーが発生しました。もう一度ページを読み込みし直してください。</div>')
}
function errorReserveDates() {
  $('#reserve-form-dates').html('<div class="reserve-form-error">通信エラーが発生しました。もう一度ページを読み込みし直してください。</div>')
}
function errorReserveTimes() {
  $('#reserve-form-times').html('<div class="reserve-form-error">通信エラーが発生しました。もう一度ページを読み込みし直してください。</div>')
}

// ポップアップ受け取り
var reserve_api_path = "https://script.google.com/macros/s/AKfycbzXjxtqbHrcrgeJgR4EiRlspPXwJe5YRNWzXcovo6PZ6N_Nx0UL5xuuaW67RAnljRi3/exec?key=gwm5328hgnwUgwYOdgw39";
//"https://script.google.com/macros/s/AKfycbzn4SOTNeNTufrgr_PSABXHy-BFWlKldwRindd0K94JK3Q_O7Ph2JguRR_nCXttGUaf/dev?key=bwUgwBgwnY7xtNtm9Psb"

/**
 * 日付情報を取得する
**/
async function getReserveDates(id, month) {
  showLoadingDate();
  let reserve_api_url = reserve_api_path + `&type=dates&at=${id}&month=${month}`;
  //console.log("api:" + reserve_api_url);
  await fetch(reserve_api_url, {
    method: 'GET' // or 'PUT'
  }).then(response => {
    response.json().then(data => {
      if (!data) {
        errorReserveDates();
      } else {
        //console.log(data);
        if (data.result == "success") {
          showReserveDates(data);
        } else if (data.result == "error") {
          // エラー
          errorReserveDates();
        } else {
          // それ以外
          errorReserveDates();
        }
      }
    })
  })
};

/**
 * 時間情報を取得する
**/
async function getReserveTimes(id, date) {
  showLoadingTime();
  let reserve_api_url = reserve_api_path + `&type=times&at=${id}&date=${date}`;
  //console.log("api:" + reserve_api_url);
  await fetch(reserve_api_url, {
    method: 'GET' // or 'PUT'
  }).then(response => {
    response.json().then(data => {
      if (!data) {
        errorReserveTimes();
      } else {
        //console.log(data);
        if (data.result == "success") {
          showReserveTimes(data);
        } else if (data.result == "error") {
          // エラー
          errorReserveTimes();
        } else {
          // それ以外
          errorReserveTimes();
        }
      }
    })
  })
};

/**
 * フォーム情報を取得する
**/
async function getReserveForm(id, datetime) {
  showLoadingItem();
  let reserve_api_url = reserve_api_path + `&type=form&at=${id}&datetime=${datetime}`;
  //console.log("api:" + reserve_api_url);
  await fetch(reserve_api_url, {
    method: 'GET' // or 'PUT'
  }).then(response => {
    response.json().then(data => {
      if (!data) {
        errorReserveForm();
      } else {
        //console.log(data);
        if (data.result == "success") {
          showReserveForm(data);
        } else if (data.result == "error") {
          // エラー
          errorReserveForm();
        } else {
          // それ以外
          errorReserveForm();
        }
      }
    })
  })
};

/**
 * フォーム情報を取得する
**/
async function registReserveForm(id, param) {
  showLoadingResult();
  // startSubmitButton();

  let reserve_api_url = reserve_api_path + `&type=regist&at=${id}`;
  //console.log("api:" + reserve_api_url);

  const response = await fetch(reserve_api_url, {
    method: 'POST',
    //mode: 'no-cors',
    //'Content-Type' : "application/x-www-form-urlencoded",
    'Content-Type' : "application/json",
    'body' : JSON.stringify(param)
  });
  //return response.json();

  const string = await response.text();
  //console.log(string);
  const json = string === "" ? {} : JSON.parse(string);
  //console.log(json);

  showReserveResult(json);
  return json;

/*
  await fetch(reserve_api_url, {
    method: 'POST', // or 'PUT'
    mode: 'no-cors',
    'Content-Type' : "application/x-www-form-urlencoded",
    'body' : JSON.stringify(param)
  }).then(response => {
    return response.json();
  }).then((data) => {
    console.log(data);
  });
*/
};


// 曜日
var weeks = ['日','月','火','水','木','金','土'];

// 日付フォーマット
function dateToStr12H(date, format) {
    if (!format) {
        format = 'Y/M/D h:m:s AP';
    }
    var hours = date.getHours();
    var ampm = hours < 12 ? 'AM' : 'PM';
    hours = hours % 12;
    hours = ( hours != 0 ) ? hours : 12; // 0時は12時と表示する
    format = format.replace(/Y/g, date.getFullYear());
    format = format.replace(/M/g, (date.getMonth() + 1));
    format = format.replace(/D/g, date.getDate());
    format = format.replace(/h/g, hours);
    format = format.replace(/W/g, weeks[date.getDay()]);
    format = format.replace(/m/g, date.getMinutes());
    format = format.replace(/s/g, date.getSeconds());
    format = format.replace(/AP/g, ampm);
    return format;
}
// 日付フォーマット 0埋め
function dateToStr12HPad0(date, format) {
    if (!format) {
        format = 'YYYY/MM/DD hh:mm:dd AP'
    }
    var hours = date.getHours();
    var ampm = hours < 12 ? 'AM' : 'PM';
    hours = hours % 12;
    hours = (hours != 0) ? hours : 12; // 0時は12時と表示する
    format = format.replace(/YYYY/g, date.getFullYear());
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/hh/g, ('0' + hours).slice(-2));
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
    format = format.replace(/WW/g, weeks[date.getDay()]);
    format = format.replace(/AP/, ampm);
    return format;
}

/**
 * テキスト内のハッシュタグやURLをリンクにする
 * @param comment
 * @returns
 */
function textToLink(comment) {
  // 正規表現でURLを抽出
  const regexp_url = /(https?:\/\/[\w/:%#\$&\?\(\)~\.=\+\-]+)/g;
  let linkedComment = comment.replace(regexp_url, '<a href="$1">$1</a>');

  // 正規表現で#を抽出
  const regexp_hash = /#+([a-zA-Z0-9亜-熙ぁ-んァ-ヶー-龥朗-鶴.\-_]+)/g;
  linkedComment = linkedComment.replace(
    regexp_hash,
    '<a href="/search?q=$1&type=hash">#$1</a>'
  );

  // 正規表現で@を抽出
  const regexp_at = /@+([a-zA-Z0-9亜-熙ぁ-んァ-ヶー-龥朗-鶴.\-_]+)/g;
  linkedComment = linkedComment.replace(
    regexp_at,
    '<a href="/search?q=$1&type=at">@$1</a>'
  );

  return linkedComment;
}

// emailバリデーション
function validation_email(text) {
  var mailformat = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (!text || text == "") {
    return false;
  }
  if (text.match(mailformat)) {
    return true;
  } else {
    return false;
  }
}
